import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { ChangeCtoComponent } from 'src/app/layout/products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/change-cto/change-cto.component';
import { ChangeFsanComponent } from 'src/app/layout/products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/change-fsan/change-fsan.component';
import { MoveCtoComponent } from 'src/app/layout/products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/move-cto/move-cto.component';
import { ValidateCtoComponent } from 'src/app/layout/products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/validate-cto/validate-cto.component';
import { CharValue } from 'src/app/models/interface/product/charValue';
import { Product } from 'src/app/models/interface/product/product';
import { Rfs } from 'src/app/models/interface/product/rfs';
import { RfsLevelObject } from 'src/app/models/tree/rfs-level-object.model';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { OrdersService, OrderSummary } from 'src/app/services/api/orders/orders.service';
import { ProductService } from 'src/app/services/api/product/product.service';
import { Task4WorkService, TaskStatusResponse } from 'src/app/services/api/task4work/task4work.service';
import { CancelInstallationComponent } from './cancel-installation/cancel-installation.component';

@Component({
  selector: 'app-order-details-installation-status',
  templateUrl: './order-details-installation-status.component.html',
  styleUrls: ['./order-details-installation-status.component.scss']
})
export class OrderDetailsInstallationStatusComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  taskExists: boolean;
  taskStatusResponse: TaskStatusResponse;
  cfsState: string;
  rfsState: string;
  specId: string;
  productOrderStatus: string;
  inventoryId: string;

  territoryOwner: string;
  portalOwner: string;

  loading: boolean;
  item: Product;

  isWholesale: boolean;
  hideInstallationButtons: boolean;

  private subscriptions = new Subscription();

  constructor(
    private dialog: MatDialog,
    private ordersService: OrdersService,
    private task4WorkService: Task4WorkService,
    private productService: ProductService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private appService: AppService) { }

  ngOnInit() {
    this.loading = false;
    this.ordersService.getProductOrderSummaryFromServiceRef(this.summary.id).subscribe(
      (data) => {
        this.inventoryId = data.inventoryId;
        this.productOrderStatus = data.status;
        this.getProductInfo(this.inventoryId);
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('INSTALLATION_STATUS.productError'), NotificationLevel.ERROR);
      }
    )
    this.task4WorkService.getTaskStatus(this.summary.externalId.split('_')[1]).subscribe(
      (data: TaskStatusResponse) => {
        this.taskStatusResponse = data;
        this.taskExists = true;
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('INSTALLATION_STATUS.error'), NotificationLevel.ERROR);
        this.taskExists = false;
      }
    );
  }

  getProductInfo(inventoryId: string) {
    this.productService.getProduct(inventoryId).subscribe(
      (data: Product) => {
        this.item = data;
        if (this.item) {
          this.cfsState = this.item.cfses[0].serviceState;
          const rfses: Array<Rfs> = this.item.cfses[0].rfses.filter(rfs => rfs.specId.includes('Access'));
          const rfs = rfses.sort((rfsA, rfsB) => Date.parse(rfsB.lastModifiedAt) - Date.parse(rfsA.lastModifiedAt));
          this.rfsState = rfs ? rfs[0].serviceState : null;
          this.portalOwner = this.appService.settings.portalOwner;
          this.isWholesale = this.item.specId.includes('Wholesale') ? true : false;
          const hiddenSpecs: string[] = this.appService.settings.hideInstallationButtonsForSpecs || [];
          this.hideInstallationButtons = hiddenSpecs.includes(this.item.specId);
          let territoryOwnerChar = this.item.cfses[0].cfsCharValues.find(serviceCharValue => serviceCharValue.specId == 'sc_network_territory_owner');
          if (territoryOwnerChar) {
            this.territoryOwner = territoryOwnerChar.value;
          } else {
            this.territoryOwner = this.portalOwner;
          }
        }
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('INSTALLATION_STATUS.productError'), NotificationLevel.ERROR);
      }
    )
  }

  cancelInstallation() {
    const matDialogRef = this.dialog.open(CancelInstallationComponent, {
      width: '850px',
      disableClose: true,
      data: {
        externalId: this.summary.externalId,
      }
    });

    matDialogRef.afterClosed()
      .pipe(
        filter(result => !!result)
      )
      .subscribe(() => {
        this.task4WorkService.getTaskStatus(this.summary.externalId.split('_')[1]).subscribe(
          (data: TaskStatusResponse) => {
            this.taskStatusResponse = data;
            this.taskExists = true;
          },
          (error) => {
            this.notificationsService.showNotification(this.translateService.instant('INSTALLATION_STATUS.error'), NotificationLevel.ERROR);
            this.taskExists = false;
          }
        );;
      })

  }

  changeCto() {
    const ino = this.territoryOwner;
    const matDialogRef = this.dialog.open(ChangeCtoComponent,
      {
        data: {
          item: this.item,
          serviceId: this.item.cfses[0].id,
          type: this.item.cfses[0].specId.split('_')[0].toLowerCase(),
          ino
        },
        disableClose: true,
        hasBackdrop: true,
        width: '70%',
        maxHeight: '70%',
        restoreFocus: false,
        autoFocus: false
      });


    matDialogRef.afterClosed()
      .pipe(
        filter(result => !!result)
      )
      .subscribe(() => {
        this.getProductInfo(this.inventoryId);
      })

  }

  moveCtoAndReprovision() {
    const matDialogRef = this.dialog.open(MoveCtoComponent,
      {
        data: {
          item: this.item,
          type: this.item.cfses[0].specId.split('_')[0].toLowerCase()
        },
        disableClose: true,
        hasBackdrop: true,
        width: '70%',
        maxHeight: '70%',
        restoreFocus: false,
        autoFocus: false
      });

    matDialogRef.afterClosed()
      .pipe(
        filter(result => !!result)
      )
      .subscribe(() => {
        this.getProductInfo(this.inventoryId);
      })
  }

  test() {
    const ino = this.territoryOwner;
    this.dialog.open(ValidateCtoComponent,
      {
        data: {
          item: this.item,
          serviceId: this.item.cfses[0].id,
          type: this.item.cfses[0].specId.split('_')[0].toLowerCase(),
          ino
        },
        restoreFocus: false,
        autoFocus: false
      })
  }

  changeFSAN() {
    const matDialogRef = this.dialog.open(ChangeFsanComponent, {
      data: {
        item: this.item,
        serviceId: this.item.cfses[0].serviceId,
        type: this.item.cfses[0].specId.split('_')[0].toLowerCase(),
        fsan: this.findFsan().value
      },
      disableClose: true,
      hasBackdrop: true,
      width: '70%',
      maxHeight: '70%',
      restoreFocus: false,
      autoFocus: false
    });

    matDialogRef.afterClosed()
      .pipe(
        filter(result => !!result)
      )
      .subscribe(() => {
        this.getProductInfo(this.inventoryId);
      })
  }

  isFSANProvisionType(): boolean {
    let provisionType = this.getProvisionType()
    if (provisionType && provisionType.value == 'FSAN') {
      return true;
    }

    return false;
  }

  getProvisionType(): CharValue {
    return this.item.cfses[0].cfsCharValues.find(characteristic => characteristic.specId === "sc_network_provision_type")
  }

  findFsan(): CharValue {
    return this.item.cfses[0].cfsCharValues.find(characteristic => characteristic.specId === "sc_network_fsan")
  }

}
